import axiosInstance from '@/utils/api.js'

var state = {
  hotspotServiceLink: []
}

var getters = {
  HOTSPOT_SERVICE_LINK: (state) => {
    return state.hotspotServiceLink
  }
}

var mutations = {
  SET_HOTSPOT_SERVICE_LINK: (state, payload) => {
    state.hotspotServiceLink = payload || []
  }
}

var actions = {
  GET_HOTSPOT_SERVICE_LINK: async (context, payload) => {
    let result = await axiosInstance.get('/users/servicelinks/hotspot?slink_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_HOTSPOT_SERVICE_LINK', result.data)
    }
  },
  CREATE_HOTSPOT_SERVICE_LINK: (context, payload) => {
    return axiosInstance.post('/users/servicelinks/hotspot', payload)
  },
  UPDATE_HOTSPOT_SERVICE_LINK: (context, payload) => {
    return axiosInstance.put('/users/servicelinks/hotspot', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/servicesLinkHotspot.js